export default __webpack_public_path__ + "images/SpeakersPhotos/foto_cesar-tello_adigital.jpg?891594e6";